@import "../../node_modules/@gbds/core/css/cadillac-2022.css";

:root {
    --numRows: 1fr;
    --columnPercentage: 25%;
}

.gb-tab-nav-custom {
    display: block;
    padding-block: 0px;
    width: 100vw;
    padding-inline: 40px;
}

.content-button.active button {
    border-bottom: 3px solid !important;
    font-weight: 600 !important;
}

.usfsn-desktop-departments-background-2000 {
    @media screen and (min-width: 2000px) {
        display: flex;
        align-items: center;
        max-width: 2000px;
        width: 100%;
        margin: 0 auto;
    }
}

.usfsn-desktop-departments-background-1216 {
    @media screen and (min-width: 1216px) {
        display: flex;
        align-items: center;
        max-width: 1216px;
        width: 100%;
        margin: 0 auto;
    }
}

.usfsn-desktop-multicolumn-container-2000 {
    @media screen and (min-width: 2000px) {
        display: flex;
        align-items: center;
        max-width: 2000px;
        width: 100%;
        margin: 0 auto;
    }
}

.usfsn-desktop-multicolumn-container-1216 {
    @media screen and (min-width: 1216px) {
        display: flex;
        align-items: center;
        max-width: 1216px;
        width: 100%;
        margin: 0 auto;
    }
}

#usfsn-desktop-view {
    font-size: 15px !important;
}

#usfsn-desktop-departments-container {
    display: inline-block;
    margin: 0px;
    position: relative;
    padding: 0px;
}

#usfsn-desktop-departments-container {
    margin-top: -20px !important;
}

#usfsn-department-button-container {
    display: inline-block;
    list-style: none;
    padding-right: 30px;
    line-height: 42px;
}

#usfsn-hovered-department-button-container {
    display: inline-block;
    list-style: none;
    padding-right: 30px;
}

#usfsn-horizontal-bar {
    position: relative;
    margin-top: -1px;
    margin-block-end: 0;
    border-bottom: 0px solid #a0a0a0;
}

.usfsn-category-container-top-bottom-padding {
    padding-top: 1.5em !important;
    padding-bottom: 1em !important;
}

.usfsn-department-button {
    appearance: none;
    background-color: transparent;
    border: 0px;
    cursor: pointer;
    height: auto;
    margin: 0px;
    padding: 40px 0px 10px;
    text-align: start;
    text-decoration: none;
    width: 100%;
}

.usfsn-hovered-department-button {
    appearance: none;
    background-color: transparent;
    border: 0px;
    cursor: pointer;
    height: auto;
    margin: 0px;
    padding: 40px 0px 10px;
    text-align: start;
    text-decoration: none;
    width: 100%;
}

.usfsn-desktop-multicolumn-1216 {
    max-width: 1216px;
    width: 100%;
}

.usfsn-desktop-multicolumn-2000 {
    max-width: 2000px;
}

.usfsn-desktop-multicolumn {
    z-index: 123;
    display: flex;
    margin-inline: -40px;
    width: 100%;
}

.usfsn-nav-grid-container {
    display: flex;
    flex-direction: column;
}

.usfsn-nav-no-underline {
    text-decoration: none;
}

.usfsn-clickable:hover {
    color: #505050 !important;
}

.usfsn-active-category {
    color: #505050 !important;
}

.usfsn-mobile-categories-font-size {
    font-size: 10px !important;
    line-height: 16px !important;
    font-style: normal;
    font-weight: 400 !important;
    letter-spacing: 0.6px;
}

.usfsn-mobile-departments-font-size {
    font-size: 10px !important;
    line-height: 16px !important;
    font-style: normal;
    font-weight: 400 !important;
    letter-spacing: 0.6px;
}

.usfsn-mobile-departments-toggle-font-styling {
    font-size: 12px !important;
    line-height: 16px !important;
    text-transform: uppercase;
}

.usfsn-custom-background-color-departments {
    background-color: #f2f2f2 !important;
}

.usfsn-mobile-custom-background-color-departments {
    background-color: #fcfcfc !important;
}

.usfsn-custom-background-color-categories {
    background-color: #f2f2f2 !important;
}

.usfsn-thick-border {
    border-bottom: 3px solid rgb(40, 40, 40) !important;
}

.usfsn-department-casing {
    text-transform: uppercase;
}

.usfsn-mobile-category-item:active {
    border-left: 3px solid #282828;
    color: #505050;
}

.usfsn-mobile-category-item:hover {
    border-left: 3px solid #282828;
    color: #505050;
}

.usfsn-mobile-current-department-item {
    border-left: 3px solid #282828;
    color: #505050;
}

.usfsn-mobile-categories-section {
    border-left: 1px solid #a0a0a0;
    gap: 16px;
    margin-block: 0px;
}

.usfsn-mobile-unselected-item {
    border-left: 3px solid #f2f2f2;
    padding-inline-start: 11.6px !important;
}

.usfsn-current-mobile-category-item {
    border-left: 3px solid #282828;
    color: #505050;
    padding-inline-start: 11.6px !important;
}

.usfsn-active-department {
    font-weight: 600 !important;
}

.usfsn-hovered-department:hover {
    color: #282828 !important;
}

.usfsn-modal-backdrop {
    width: 100vw;
    height: 100vh;
    background-color: #141414;
    opacity: 70%;
}

.usfsn-mobile-depcat-box-child {
    display: inline-block;
    vertical-align: top;
}

.usfsn-mobile-departments-section {
    margin: 10px 1px;
    padding-inline: 15px;
    display: flex;
    flex-direction: column;
    z-index: 1;
    border-right: 1px solid #a0a0a0;
}

.usfsn-mobile-item-spacing {
    padding: 10px 8px;
    margin: 6px -1px;
}

.usfsn-mobile-categories-section {
    margin: 6px -2px;
    width: 100%;
    overflow: -moz-scrollbars-none;
    -ms-overflow-style: none;
    z-index: 2;
}

.usfsn-mobile-categories-section::-webkit-scrollbar {
    width: 0 !important;
}

.usfsn-mobile-vertical-scroll {
    overflow: auto;
}

.usfsn-vertical-display {
    display: block;
}

.usfsn-fullwidth {
    width: 100%;
}

.usfsn-rightfloat {
    float: right;
}

.usfsn-leftfloat {
    float: left;
}

.usfsn-mobile-department-item {
    margin-left: -16px !important;
}

.usfsn-mobile-content-button {
    padding-inline: 20px !important;
}

.usfsn-mobile-nopadding {
    padding: 0 !important;
}

.usfsn-toggle-flipped {
    transform: rotate(180deg);
}

#usfsn-mobile-categories-container-inner {
    display: flex;
    flex-direction: column;
}

#usfsn-mobile-content-container {
    display: flex;
    flex-direction: initial;
    position: absolute;
    z-index: 123;
}

.usfsn-mobile-nav-section-styles {
    position: relative;
    width: 100vw;
}

.usfsn-mobile-section-styles {
    position: relative;
    width: 100vw;
}

.usfsn-custom-nav-background {
    background-color: rgb(242, 242, 242) !important;
}

#usfsn-nav-container {
    padding-inline: 40px !important;
}

#usfsn-category-container {
    z-index: 123;
    padding: 0px 40px;
    gap: 8px;
    width: calc(100% / 4);
}

#usfsn-mobile-main-toggle-container {
    margin-top: -20px;
    position: relative;
}

#usfsn-mobile-nav-container {
    padding-inline: 32px;
    padding: 0px;
}

#usfsn-mobile-main-toggle-container {
    width: 100%;
    display: inline-block;
    margin: 0px;
}

#usfsn-mobile-main-toggle-line {
    display: inline-block;
    list-style: none;
    margin-top: -20px;
}

#usfsn-mobile-main-toggle-button {
    letter-spacing: 1.6px;
    line-height: 1.5714;
    appearance: none;
    background-color: transparent;
    border: 0px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 200;
    height: auto;
    margin: 0px;
    padding: 40px 0px 10px;
    text-align: start;
    text-decoration: none;
    width: 100%;
    color: rgb(40, 40, 40);
}

#usfsn-nav-backdrop {
    position: absolute;
    z-index: 122;
}

.usfsn-typography {
    font-family: CadillacGothic;
}

.usfsn-category-empty-gap {
    padding-block-start: 20px;
}

.usfsn-department-label {
    font-family: CadillacGothicBold;

    font-size: 16px !important;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;

    color: #282828;
}

.usfsn-category-label {
    font-size: 12px !important;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.6px;

    color: #0d0d0d;
}

.usfsn-category-header {
    font-size: 10px !important;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0.55px;
    margin-block-end: 0px;

    color: #666;
}

.usfsn-department-home {
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 26px;
    letter-spacing: 1.14px;
    text-decoration: none;

    display: inline-block;
    padding: 1.5em 0px 0px 0px;

    color: #000;
}

.usfsn-mobile-department-home {
    font-size: 14px !important;
    font-style: normal;
    font-weight: 400;
    line-height: 23px;
    letter-spacing: 1px;

    margin-block-start: 16px;
    margin-block-end: 0px;
    text-decoration: none;

    color: #000;
}

.usfsn-category-column-padding {
    padding-inline-start: 16px;
    margin-block-end: -32px;
}

.usfsn-mobile-category-column-text {
    margin-block: 0px;
    padding-block: 0px;

    font-size: 10px !important;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.55px;

    color: #0d0d0d;
}

.usfsn-mobile-category-header-gap {
    padding-top: 32px;
}

.usfsn-mobile-department-item {
    font-family: CadillacGothicBold;

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 180%;
    letter-spacing: 0.63px;

    margin-left: -16px !important;
    padding: 10px 8px;
    margin: 6px -1px;
}

.usfsn-mobile-category-header {
    font-size: 10px !important;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0.55px;

    color: #666;
}

.usfsn-department-home-container {
    margin: 0 auto;
}
